<ng-container *ngIf="globalService.isDataLoaded; else loading">
  <div>
    <app-header></app-header>
    <div class="container">
      <app-ordonnance-list></app-ordonnance-list>
    </div>
  </div>
</ng-container>
  
<ng-template #loading>
    <img class="loading" [src]="loading_gif" alt="Loading" width="120" height="120"/>
</ng-template>